import React from 'react';
import { Typography } from '@mui/material';
import styled from 'styled-components';

import { colors } from 'theme';

const StyledFieldset = styled.fieldset`
  padding: 1rem;

  border-color: ${colors.blueGrey_50};

  & > *:not(:last-child),
  & > *:not(:first-child) {
    margin-bottom: 1rem;
  }
`;

const StyledLegend = styled.legend`
  padding: 0 0.5rem;
`;

interface FieldsetProps {
  legend: string;
  children: React.ReactNode;
}

const Fieldset: React.FC<FieldsetProps> = ({ legend, children }) => {
  return (
    <StyledFieldset>
      <StyledLegend>
        <Typography>{legend}</Typography>
      </StyledLegend>
      {children}
    </StyledFieldset>
  );
};

export default Fieldset;
